import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useMemo } from 'react'
import { BsChevronRight } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'

const ModalEcommerce = ({ isOpen, setIsOpen, data = [] }) => {
  function closeModal () {
    setIsOpen(false)
  }

  const toSafeHref = (url) => {
    if (typeof url !== 'string') return undefined
    return /^https?:\/\//i.test(url) ? url : undefined
  }

  const getProductCode = (url) => {
    try {
      const u = String(url || '')
      const parts = u.split('/').filter(Boolean)
      return parts.length ? parts[parts.length - 1] : ''
    } catch {
      return ''
    }
  }

  const items = useMemo(() => Array.isArray(data) ? data : [], [data])

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as='div' className='relative z-50' onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300 motion-reduce:duration-0'
              enterFrom='opacity-0 scale-95 motion-reduce:opacity-100 motion-reduce:scale-100'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200 motion-reduce:duration-0'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95 motion-reduce:opacity-100 motion-reduce:scale-100'
            >
              <Dialog.Panel className='relative w-full max-w-xl bg-white shadow-md rounded-xl overflow-hidden transition-all'>
                <div className='sticky top-0 bg-[#2C2C2C] p-4 text-center text-white z-10'>
                  <Dialog.Title as='h3' className='text-xl font-semibold'>
                    View on the Brand’s
                  </Dialog.Title>
                  <p className='text-x1'>
                    Open the product page for details and specifications.
                  </p>

                  <button
                    onClick={closeModal}
                    aria-label='Close'
                    className='absolute right-2 top-2 h-8 w-8 rounded-lg
                               flex items-center justify-center
                               bg-red-500 hover:bg-red-600 active:bg-red-700
                               text-white focus:outline-none
                               focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-red-500'
                  >
                    <MdClose fontSize={22} />
                  </button>
                </div>

                <div className='p-5'>
                  {items.length === 0 ? (
                    <div className='text-center text-slate-500 py-6'>
                      Belum ada link produk.
                    </div>
                  ) : (
                    items.map((item) => {
                      const safeHref = toSafeHref(item?.product_link)
                      const code = getProductCode(item?.product_link)

                      return (
                        <div
                          key={item?.id ?? code}
                          className='md:flex gap-3 justify-between items-center py-3 px-5 my-4 rounded-xl bg-[#E6FFFB]'
                        >
                          <div className='w-24 flex mx-auto justify-center'>
                            <img
                              className='w-20 h-9 object-contain'
                              src={`${process.env.REACT_APP_IMAGE}/${item?.ecommerces?.imageIcon ?? ''}`}
                              alt={item?.ecommerces?.title ? `${item.ecommerces.title} logo` : 'Brand logo'}
                              loading='lazy'
                              decoding='async'
                              width={80}
                              height={36}
                              onError={(e) => { e.currentTarget.style.visibility = 'hidden' }}
                            />
                          </div>

                          <div className='flex-1 text-start text-[#333]'>
                            <span>Type Product:</span>
                            <span className='font-semibold ml-2 break-all text-primary'>
                              {code || item?.ecommerces?.title || 'Product'}
                            </span>
                          </div>

                          <a
                            className={`flex gap-2 items-center my-1 md:my-0 py-2 px-3 rounded-md text-white duration-200
                                       ${safeHref
                                         ? 'bg-[#2C2C2C] hover:bg-[#008277]'
                                         : 'bg-slate-400 cursor-not-allowed'}`}
                            href={safeHref || '#'}
                            target={safeHref ? '_blank' : undefined}
                            rel={safeHref ? 'noopener noreferrer' : undefined}
                            onClick={(e) => { if (!safeHref) e.preventDefault() }}
                          >
                            <span className='text-sm'>See More</span>
                            <BsChevronRight />
                          </a>
                        </div>
                      )
                    })
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ModalEcommerce
